import { handleApiCall } from "../api";

export const getUserByRoleId = (roleID = 1) => handleApiCall('get', `/users/${roleID}`);

export const getProfileData = () => handleApiCall('get', `/users/auth/profile`);


// User API Service 
export const getUserData = (page = 1, limit = 10, search?: string, roleId?: number) => {
  let url = `users?page=${page}&limit=${limit}`;
  
  // Add search parameter if provided
  if (search) {
    url += `&search=${search}`;
  }
  
  // Only include role_id if explicitly provided (from Roles page)
  // If undefined, don't include it (My Users mode - shows users managed by current user)
  if (roleId !== undefined && roleId !== null) {
    url += `&role_id=${roleId}`;
  }
  
  return handleApiCall('get', url);
};

export const getUserById = (id) => handleApiCall('get' ,`/users/${id}`);

export const getAllUsers = (page = 1, limit = 10) => handleApiCall('get' , `/users?page=${page}&limit=${limit}&group=all`);

export const createUser = (postPayload) => handleApiCall('post', `/users`, postPayload);

export const updateUser = (id, patchPayload) => handleApiCall('patch', `/users/${id}`, patchPayload);

export const resendPassword = (id) => handleApiCall('post', `/users/${id}/password-resend`, {});

// Notification Preferences
export const getNotificationPreferences = () => handleApiCall('get', `/notifications/preferences`);
export const updateNotificationPreferences = (payload: { receive_order_notifications: boolean }) =>
  handleApiCall('patch', `/notifications/preferences`, payload);

// Admin: Notification Preferences for a specific user
export const getAdminNotificationPreferences = (userId: number) =>
  handleApiCall('get', `/notifications/preferences/${userId}`);
export const updateAdminNotificationPreferences = (userId: number, payload: { receive_order_notifications: boolean }) =>
  handleApiCall('patch', `/notifications/preferences/${userId}`, payload);

// Stores API Service 

export const getStores = (page=1,limit=200) => handleApiCall('get' ,`stores?page=${page}&limit=${limit}&group=all`);